'use strict';

module.exports = ger;

function ger () {
  console.error('GER (rank 1 operation A := alpha*x*y\' + A) not yet implemented');
}
